import React from "react";
import DeviceBasedRenderer from "../../../../components/common/DeviceBasedRenderer";
import OrganismDisplayViewInfoPreviewDesktop from "./OrganismDisplayViewInfoPreviewDesktop";
import OrganismDisplayViewInfoPreviewMobile from "./OrganismDisplayViewInfoPreviewMobile";

const OrganismDisplayViewInfoPreview = (props) => {
  console.log("🎯 기기별 미리보기 라우터 - OrganismDisplayViewInfoPreview");

  return (
    <DeviceBasedRenderer
      DesktopComponent={OrganismDisplayViewInfoPreviewDesktop}
      MobileComponent={OrganismDisplayViewInfoPreviewMobile}
      AndroidComponent={OrganismDisplayViewInfoPreviewMobile} // 안드로이드도 모바일 컴포넌트 사용
      IOSComponent={OrganismDisplayViewInfoPreviewMobile} // iOS도 모바일 컴포넌트 사용
      {...props} // 모든 props를 하위 컴포넌트에 전달
    />
  );
};

export default OrganismDisplayViewInfoPreview;
